const ROOT_URL = "https://api.realworld.io/api/";
const articlesURL = ROOT_URL + "articles";
const tagsURL = ROOT_URL + "tags";
const localStorageKey = "app_user";
const loginURL = ROOT_URL + "users/login";
const registerURL = ROOT_URL + "users";
const verifyURL = ROOT_URL + "user";
const profileURL = ROOT_URL + "profiles";

export {
  ROOT_URL,
  articlesURL,
  tagsURL,
  loginURL,
  registerURL,
  localStorageKey,
  verifyURL,
  profileURL,
};
